import { cn } from '@/lib/utils';
import type { To } from 'react-router-dom';
import { Link } from 'react-router-dom';

type Props = {
    align?: 'left' | 'center' | 'right';
    className?: string;
    topClassName?: string;
    bottomClassName?: string;
    id: React.ReactNode | string;
    title: React.ReactNode | string;
    to: To;
    onClick?: () => void;
};

export const IdAndNameCell: React.FC<Props> = ({
    to,
    align = 'left',
    className,
    topClassName,
    bottomClassName,
    id,
    title,
    onClick,
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-1.5 leading-[18px]',
                align === 'left' && 'items-start text-left',
                align === 'center' && 'items-center text-center',
                align === 'right' && 'items-end text-right',
                className,
            )}
        >
            <Link
                to={to}
                onClick={(e) => {
                    if (onClick && !e.ctrlKey && !e.metaKey) {
                        e.preventDefault();
                        onClick();
                    }

                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }}
            >
                <div className={cn('flex items-center text-blue-700', topClassName)}>{id}</div>
            </Link>
            <div className={cn('flex items-center', bottomClassName)}>{title}</div>
        </div>
    );
};
